import React from 'react'
import NavBar from '../Components/NavBar'
import Banner from './Banner'
import About from './About'
import Toolbox from '../Components/Toolbox'
import Experience from './Experience'
import Projects from './Projects'
import Contact from './Contact'
import Anim from '../Components/Anim_bg/Anim'



const Pages = () => {
  return (
    <>
        <Anim/>
        <NavBar />
        <Banner />
        <About/>
        <Toolbox/>
        <Experience/>
        <Projects/>
        <Contact/>
    </>
  )
}

export default Pages